"use strict";
/**
 * Venue registry — the one place a `VenueId` becomes an implementation.
 *
 * Static imports, not dynamic. The bundle is already over webpack's size
 * warning and Novig will add to it, but code-splitting the order path would put
 * a network fetch between click and exchange, which is the one thing this app
 * must never do (ai/ARCHITECTURE.md). Bundle size is a real follow-up; the
 * order path is not where it gets paid.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVenue = getVenue;
exports.hasVenue = hasVenue;
exports.listVenues = listVenues;
exports.listSelectableVenues = listSelectableVenues;
const venues_1 = require("../../shared/venues");
const kalshi_adapter_1 = require("./kalshi-adapter");
const novig_adapter_1 = require("./novig-adapter");
const pm_us_adapter_1 = require("./pm-us-adapter");
const polymarket_adapter_1 = require("./polymarket-adapter");
const ADAPTERS = {
    kalshi: kalshi_adapter_1.kalshiAdapter,
    polymarket: polymarket_adapter_1.polymarketAdapter,
    "pm-us": pm_us_adapter_1.pmUsAdapter,
    novig: novig_adapter_1.novigAdapter,
};
/**
 * The adapter for a venue.
 *
 * Throws on an unregistered venue rather than returning undefined: a missing
 * adapter surfaces here, at the lookup, instead of as a `cannot read property`
 * three frames deeper in whatever was about to place an order.
 */
function getVenue(id) {
    const adapter = ADAPTERS[id];
    if (!adapter) {
        throw new Error(`No venue adapter registered for "${id}"`);
    }
    return adapter;
}
/** Is there an implementation for this venue yet? */
function hasVenue(id) {
    return ADAPTERS[id] !== undefined;
}
/** Every registered adapter. */
function listVenues() {
    return Object.values(ADAPTERS).filter((adapter) => adapter !== undefined);
}
/** Adapters for venues the operator may currently select. */
function listSelectableVenues() {
    return venues_1.DATA_SOURCES.filter(hasVenue).map(getVenue);
}
